<template>
	<v-dialog
			:value="isPlanerDayOff"
			content-class="contentDayOff"
			persistent
			width="950"
	>
		<div class="planerDayOffPopup">
			<div class="planerDayOffPopup_title">
				<span class="planerDayOffPopup_title-indicator">{{ dayOffId ? 'Edit' : 'Add' }} day off</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="groupFieldWrapper" :class="{ 'mb-5': !list, 'disabled': !permissions[9] }">
				<div class="groupField_wrap">
					<field
							:class-error="getError('box')"
							margin="0 10px 10px 0"
							width="282px"
							label="BOX #"
							placeholder="Select option"
							@updateMultiSelect="onAutocomplete($event, 'box')"
							:multiValue="box"
							:items="boxes"
							is-multiple
							is-btn-all
							is-attach
							is-required
					></field>
					<field
							:class-error="getError('start_day')"
							margin="0 10px 10px 0"
							width="282px"
							type="text"
							label="Start date"
							placeholder="Enter date"
							display-format="YYYY-MM-DD hh:mm"
							:dateValue="start_day"
							@updateTime="onDate($event, 'start_day')"
							is-time
							is-required
					></field>
					<field
							:class-error="getError('end_day')"
							margin="0 10px 10px 0"
							width="282px"
							type="text"
							label="End date"
							display-format="YYYY-MM-DD hh:mm"
							placeholder="Enter date"
							:dateValue="end_day"
							@updateTime="onDate($event, 'end_day')"
							is-time
							is-required
					></field>
				</div>
			</div>
			<div class="groupFieldWrapper mb-5">
				<div class="top">
<!--					<field
							margin="0"
							padding="0"
							labelSwitch="Split work orders "
							:switchValue="split"
							@updateSwitch="onSwitch"
							is-switch
							is-dense
					></field>-->
					<warn-block is-orange margin="0" text="Work orders that overlapped with day off"></warn-block>
				</div>
				<preload v-if="isPreloader"></preload>
				<planer-work-orders-table
						:list-items="list"
						@updateCheckOrder="onCheckOrder"
						@updateCheckOrders="onCheckOrders"
				></planer-work-orders-table>
			</div>
			<button-groups
					@updateBtnClose="onClose"
					@updateDelete="onDelete"
					@updateSave="onSave"
					apply-text="SUBMIT"
					:is-btn-delete="isDelItem"
					:is-btn-safe="!permissions[9]"
			></button-groups>
		</div>
	</v-dialog>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// components
import PlanerWorkOrdersTable from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerWorkOrdersTable/PlanerWorkOrdersTable";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import WarnBlock from "@/shared/WarnBlock/WarnBlock";
import Preload from "@/shared/Preload/Preload";
// helpers
import debounce from "lodash.debounce";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment/moment";

export default {
	name: "PlanerDayOff",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups,
		WarnBlock,
		Preload,
		PlanerWorkOrdersTable
	},
	props: {
		dayOffId: Number,
		permissions: Object
	},
	computed: {
		isDelItem() {
			if (this.permissions[9]) {
				if (this.permissions[11]) {
					return !!this.dayOffId;
				}
			}

			return false;
		}
	},
	data: () => ({
		isPreloader: false,
		isPlanerDayOff: true,
		start_day: null,
		end_day: null,
		box: [],
		split: null,
		boxes: [],
		list: [],
		orders: []
	}),
	validations: {
		end_day: { required },
		start_day: { required },
		box: { required }
	},
	methods: {
		...mapActions([ 'onDayOffCreate', 'onDayOff', 'onDayOffFilter', 'setAlert', 'getDayOffEdit', 'onDayOffEdit' ]),
		getError(key) {
			return this.$v[key]?.$error;
		},
		onAutocomplete({ value }, key) {
			this[key] = value;

			this.onSetDayOffData();
		},
		async onSetDayOffData() {
			if (this.box.length && this.start_day && this.end_day) {
				const boxes = this.box.map(item => item.id);
				this.onRequestDayOff({ boxes, start_day: this.start_day, end_day: this.end_day });
			}
		},
		onRequestDayOff: debounce(async function(values) {
			this.isPreloader = true;
			const { rows } = await this.onDayOffFilter(values);
			this.list = rows;
			this.isPreloader = false;
		}, 500),
		onSwitch({ value }) {
			this.split = value;
		},
		onDate(date, key) {
			this[key] = date;
			this.onSetDayOffData();
		},
		onClose() {
			this.$emit('updateClose');
		},
		onDelete() {
			this.$emit('updateDelete', this.dayOffId);
		},
		onCheckOrder(id) {
			const idx = this.orders.findIndex(item => item === id);
			if (idx === -1) {
				this.orders.push(id);
			} else {
				this.orders.splice(idx, 1);
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.orders = this.list.map(item => item['order_id']);
			} else {
				this.orders = [];
			}

			this.list.forEach(item => item.isCheck = value);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					box,
					start_day,
					end_day,
					split
				} = this.$data;
				const boxes = box.map(item => item.id || item);
				const values = {
					boxes,
					start_day,
					end_day,
					split: Number(split)
				};

				if (this.dayOffId) values.id = this.dayOffId;
				const validTime = moment(start_day).isBefore(end_day);

				if (validTime) {
					const request = this.dayOffId ? 'onDayOffEdit' : 'onDayOff';
					const { status } = await this[request](values);
					if (status) {
						this.$emit('updateSuccess');
						this.onClose();
						this.setAlert({ type: "success", message: "Saving Successfully" });
					} else {
						this.setAlert({ type: "error", message: "Saving error" });
					}
				} else {
					this.setAlert({ type: "error", message: "Start of work, should be less than the end of work" });
				}
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		}
	},
	async mounted() {
		this.isPreloader = true;
		if (this.dayOffId) {
			const { rows, boxes, seletcBox, dayOff } = await this.getDayOffEdit(this.dayOffId);
			this.boxes = boxes;
			this.box = seletcBox;
			this.list = rows;
			this.end_day = dayOff.end_day;
			this.start_day = dayOff.start_day;
		} else {
			const { rows, boxes } = await this.onDayOffCreate();
			this.boxes = boxes;
			this.box = boxes;
			this.list = rows;
		}

		this.isPreloader = false;
	}
};
</script>

<style scoped lang="scss">
@import "PlanerDayOff";
</style>

<style lang="scss">
@import "PlanerDayOffAll";
</style>
